export const ColorPalette = {
  primary: {
    dark: '#98314c',
    main: '#D23F57',
    light: '#ea92a7',
    backdrop: '#fae4e9',
  },
  secondary: {
    main: '#00997a',
  },
  error: {
    main: '#f44336',
  },
  background: {
    default: '#fafafa',
    paper: '#fff',
  },
  text: {
    dark: 'rgba(0,0,0,0.87)',
    light: '#fff',
    disable: 'rgba(0,0,0,0.26)',
  },
  disabled: 'rgba(0,0,0,0.12)',
  lightBorder: 'rgba(0,0,0,0.18)',
};
